import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";

import { ReactComponent as ArrowUpSvg } from "@/assets/images/desktop/Flechaverdehorizontal.svg";
import { ReactComponent as ArrowDownSvg } from "@/assets/images/desktop/flechaverdeabajo.svg";

import OrdersSaleActionItem from "./Action/OrdersSaleActionItem";
import OrdersSaleTableBodyDetail from "./OrdersSaleTableBodyDetail";

import { agricolaName, dateToLocale, formatMiles, formatMilesDecimal, formatMilesDecimalNew } from "@/services/Utils";

import classes from "../../purchase.module.scss";

const OrdersSaleTableBody = ({ data, setData, base }) => {
	return (
		<tbody>
			{data &&
				data.map((item, i) => {
					return [
						<tr key={i} className={`${classes.table_tr}`}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div
									className={`${classes.table_div} ${classes.first_div} ${item.active && classes.active} ${classes.long_text} ${
										classes.center
									}`}
								>
									<CustomTooltip text={agricolaName(item.business_name)} description={item.business_name} />
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>
									{item && item.created_date && dateToLocale(item.created_date)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div
									className={`${classes.table_div} ${item.active && classes.active} ${classes.long_text} ${classes.center}`}
									style={{ textAlign: "center" }}
								>
									<CustomTooltip
										text={item.dealer_name.length < 5 ? item.dealer_name : agricolaName(item.dealer_name)}
										description={item.dealer_name}
									/>
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>{item && item.dealer_number}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active} ${classes.list}`}>
									{item &&
										item.orders &&
										item.orders.length !== 0 &&
										item.orders.map((o, j) => {
											return (
												<a
													key={j}
													href={`/ordenes_compra/editar/${o.code_oc}`}
													target="__blank"
													style={{
														color: "black",
														fontWeight: "400",
													}}
												>
													<p
														style={{
															marginBottom: "0px",
														}}
													>
														{o.code_oc}
													</p>
												</a>
											);
										})}
								</div>
							</td>

							<td className={`${classes.table_td}`}>
								<div
									className={`${classes.table_div} ${item.active && classes.active}`}
									style={{
										textAlign: "center",
										backgroundColor: Number(item.reception) < 100 ? "#ff030359" : Number(item.reception) === 100 && "#7fb02f59",
										color: Number(item.reception) < 100 ? "red" : Number(item.reception) === 100 && "green",
									}}
								>
									{item && item.reception ? formatMilesDecimalNew(String(item.reception).replace(".", ",")) : 0}%
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>
									{item && item.date_orders_sale && dateToLocale(item.date_orders_sale)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>
									{item && item.quantity && formatMiles(item.quantity)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>
									${item && item.price_total && formatMilesDecimal(item.price_total)}
								</div>
							</td>

							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`} style={{ position: "relative" }}>
									<OrdersSaleActionItem item={item} indice={i} data={data} base={base} />
								</div>
							</td>
							<td
								onClick={() => {
									let newData = [...data];
									newData.forEach((element, j) => {
										if (!newData[i].active) {
											newData[j].active = false;
										}
									});
									newData[i].active = !newData[i].active;
									setData(newData);
								}}
								className={`${classes.table_td}`}
							>
								<div className={`${classes.table_div} ${item.active && classes.active} ${classes.last_div}`}>
									{item.active ? <ArrowDownSvg /> : <ArrowUpSvg />}
								</div>
							</td>
						</tr>,
						<OrdersSaleTableBodyDetail item={item} base={base} key={`detail_${i}`} />,
					];
				})}
		</tbody>
	);
};

export default OrdersSaleTableBody;
